<template>
  <v-container fluid class="home-main-container">
    <v-row justify="center" align="center">
      <v-card class="pa-5">
        <h1 class="text-center">Serviços Administrativos</h1>
        <p class="text-center">Secretaria Municipal da Educação de Campo Mourão-PR</p>
        <div justify="center" align="center">
        <v-img src="@/assets/logoseced.webp" alt="Logo SEED" contain max-width="200" class="my-4"></v-img>
        </div>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HomeMain",
};
</script>

<style scoped>
.home-main-container {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 32px;
}
</style>
